import { render } from "./InvoiceStateInfo.vue?vue&type=template&id=4490ed9a&ts=true"
import script from "./InvoiceStateInfo.vue?vue&type=script&lang=ts"
export * from "./InvoiceStateInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/app/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__